import React from 'react';
import { Icon } from './Icon';

const PlusIcon = ({ size }: Props) => {
  return (
    <Icon type="plus" color="bg-label-secondary" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { PlusIcon };